import React from 'react';

// Small centered play-icon overlay for compact video thumbnails (inline chat
// cards). No inline playback here — this only signals "this is a video";
// clicking through opens the full message the same as any other card.
const PlayIconOverlay = ({ size = 72 }) => {
    const circleSize = Math.max(20, Math.round(size * 0.36));

    return (
        <span
            style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: `${circleSize}px`,
                height: `${circleSize}px`,
                borderRadius: '50%',
                background: 'rgba(0, 0, 0, 0.55)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none'
            }}
        >
            <svg
                width={circleSize * 0.42}
                height={circleSize * 0.42}
                viewBox="0 0 16 16"
                fill="none"
                style={{ marginLeft: '2px' }}
            >
                <path d="M3.5 1.8v12.4a0.8 0.8 0 001.22.68l9.7-6.2a0.8 0.8 0 000-1.36l-9.7-6.2A0.8 0.8 0 003.5 1.8z" fill="#fff" />
            </svg>
        </span>
    );
};

// Full-size video previews use this fixed-size version. Keeping it shared
// ensures uploaded videos and YouTube/link previews have the same play cue.
export const VideoPlayOverlay = ({ isHovered = false }) => (
    <span
        aria-hidden="true"
        data-testid="video-play-overlay"
        style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            zIndex: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 44,
            height: 44,
            transform: `translate(-50%, -50%) scale(${isHovered ? 1.08 : 1})`,
            borderRadius: '50%',
            background: isHovered ? 'rgba(0, 0, 0, 0.82)' : 'rgba(0, 0, 0, 0.68)',
            color: '#fff',
            fontSize: 18,
            fontWeight: 700,
            lineHeight: 1.2,
            pointerEvents: 'none',
            boxShadow: isHovered ? '0 4px 14px rgba(0, 0, 0, 0.45)' : '0 2px 8px rgba(0, 0, 0, 0.35)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            transition: 'transform 0.15s ease, background 0.15s ease, box-shadow 0.15s ease'
        }}
    >
        ▶
    </span>
);

export default PlayIconOverlay;
